<template>
    <v-container fluid>
        <activation-form
            v-if="model"
            :model="model"
            :titlePrefix="$t('forms.title_prefix.edit')"
            @saved="saved"
        />
        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import ActivationForm from './Form'
import Activation from '@/models/Activation'

export default {
    props: {
        id: {
            required: true,
        },
    },

    components: {
        ActivationForm,
    },

    data: () => {
        return {
            model: null,
        }
    },

    methods: {
        async findActivation() {
            this.model = await new Activation().find(this.id)
        },

        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.findActivation()
    },
}
</script>

<style></style>
